import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../../services/component.service';
import { SlipModalComponent } from '../../slip-modal';
import { WebClientService } from '../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * End Component
 */
let EndGuestComponent = class EndGuestComponent {
    constructor(route, router, webSettingsService, sanitizer, themeService, compService) {
        this.route = route;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.compService = compService;
        this.textColor = '';
        this.mainColor = '';
        this.paymentButtonColor = '';
        this.outcome = null;
        this.accentColor = '';
        this.errorColor = '';
        this.borderRadiusLarger = '';
        this.webSettingsService.getSettings().subscribe(data => {
            if (!this.webSettingsService.applySettings('GUEST_USER.ON')) {
                this.router.navigate(['/']);
            }
        });
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.paymentButtonColor = this.themeService.getStyleAttribute('payment_button_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.sub = this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.outcome = params['outcome'];
        });
        this.txType = localStorage.getItem('orderType');
    }
    ngOnInit() {
    }
    openModal() {
        this.compService.openModal(SlipModalComponent, {
            order_id: +this.orderId
        });
    }
};
EndGuestComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: ComponentService }
];
EndGuestComponent = __decorate([
    Component({
        selector: 'ecd-guest-end',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./end.component.html")).default
    })
], EndGuestComponent);
export { EndGuestComponent };
